import * as actionTypes from "../actions/actionTypes";

const initialState = {
  skills: [],
  loading: false,
  error: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_SKILLS_START:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case actionTypes.FETCH_SKILLS_SUCCESS:
      return {
        ...state,
        skills: action.skills,
        loading: false,
        error: null,
      };

    case actionTypes.FETCH_SKILLS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    default:
      return state;
  }
};

export default reducer;
